import { useTranslation } from 'react-i18next';
import { MAIN_WEBSITE_URL } from '@/mocks/site';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="bg-primary-600 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold tracking-tight text-background-50">
          {t('cta.title')}
        </h2>
        <p className="mt-4 text-sm md:text-base text-primary-50 leading-relaxed">
          {t('cta.subtitle')}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#categories"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 transition-colors cursor-pointer"
          >
            {t('cta.btnExplore')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-layout-grid-line text-base" aria-hidden="true"></i>
            </span>
          </a>
          <a
            href={MAIN_WEBSITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 hover:bg-accent-600 transition-colors cursor-pointer"
          >
            {t('cta.btnVisit')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}